import React from 'react';
import {ThemedHeader} from '../Styled';

export default class Reviews extends React.PureComponent {
    componentDidMount() {
        if (window.FB)
            window.FB.XFBML.parse()
    }

    render() {
        return (
            <React.Fragment>
                <ThemedHeader style={{marginTop: '50px'}}>Reviews</ThemedHeader>
                <div style={{
                    margin:       '50px auto 20px auto',
                    maxWidth:     '1183px',
                    paddingLeft:  '30px',
                    paddingRight: '30px'
                }}>
                    <div className='fb-comments'
                         data-href='http://paraglideutah.com/testimonials'
                         data-colorscheme='light'
                         data-numposts='10'
                         data-order-by='reverse_time'
                         data-width='100%'/>
                </div>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Reviews.js